/**
 * Funnel Pages — AJAX Cart, Sticky CTA, & Analytics
 */
(function () {
  'use strict';

  /* ---- AJAX Add to Cart ---- */
  function addToCart(variantId, button) {
    if (!variantId || button.disabled) return;

    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart error');
        return res.json();
      })
      .then(function (item) {
        button.textContent = 'Added!';
        button.classList.add('funnel-btn--added');

        // Push analytics event
        pushDataLayer('funnel_add_to_cart', {
          variant_id: variantId,
          product_title: item.title,
          price: item.price
        });

        // Dispatch native Shopify-compatible event
        document.dispatchEvent(new CustomEvent('cart:added', { detail: { item: item } }));

        setTimeout(function () {
          button.textContent = originalText;
          button.classList.remove('funnel-btn--added');
          button.disabled = false;
        }, 2000);
      })
      .catch(function () {
        button.textContent = 'Try again';
        button.disabled = false;
        setTimeout(function () {
          button.textContent = originalText;
        }, 2000);
      });
  }

  // Delegated click handler for all funnel add-to-cart buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.funnel-add-to-cart');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn.dataset.variantId, btn);
  });

  /* ---- Sticky CTA Bar ---- */
  function initStickyCta() {
    var stickyBar = document.querySelector('.funnel-sticky-bar');
    if (!stickyBar) return;

    var sentinel = document.querySelector('[data-funnel-sticky-sentinel]');
    if (!sentinel) {
      // Fallback: show after scrolling 600px
      var shown = false;
      window.addEventListener('scroll', function () {
        if (window.scrollY > 600 && !shown) {
          stickyBar.classList.add('funnel-sticky-bar--visible');
          shown = true;
        } else if (window.scrollY <= 600 && shown) {
          stickyBar.classList.remove('funnel-sticky-bar--visible');
          shown = false;
        }
      }, { passive: true });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            stickyBar.classList.remove('funnel-sticky-bar--visible');
          } else {
            stickyBar.classList.add('funnel-sticky-bar--visible');
          }
        });
      },
      { threshold: 0 }
    );

    observer.observe(sentinel);
  }

  /* ---- Analytics Helpers ---- */
  function pushDataLayer(eventName, data) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: eventName };
    if (data) {
      for (var key in data) {
        if (data.hasOwnProperty(key)) payload[key] = data[key];
      }
    }
    window.dataLayer.push(payload);
  }

  // Track when sections with [data-funnel-track] enter viewport
  function initSectionTracking() {
    var sections = document.querySelectorAll('[data-funnel-track]');
    if (!sections.length) return;

    var tracked = {};
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var name = entry.target.dataset.funnelTrack;
            if (!tracked[name]) {
              tracked[name] = true;
              pushDataLayer('funnel_section_view', { section_name: name });
            }
          }
        });
      },
      { threshold: 0.3 }
    );

    sections.forEach(function (el) {
      observer.observe(el);
    });
  }

  // Track video play events
  function initVideoTracking() {
    var videos = document.querySelectorAll('.funnel-vsl-video');
    videos.forEach(function (video) {
      video.addEventListener('play', function () {
        pushDataLayer('vsl_video_play', {});
      });
      video.addEventListener('timeupdate', function () {
        if (video.duration && video.currentTime / video.duration >= 0.5) {
          if (!video.dataset.tracked50) {
            video.dataset.tracked50 = '1';
            pushDataLayer('vsl_video_50pct', {});
          }
        }
      });
      video.addEventListener('ended', function () {
        pushDataLayer('vsl_video_complete', {});
      });
    });
  }

  /* ---- FAQ Accordion ---- */
  function initFunnelFaq() {
    var faqSection = document.querySelector('.funnel-faq');
    if (!faqSection) return;

    faqSection.addEventListener('click', function (e) {
      var question = e.target.closest('.funnel-faq__question');
      if (!question) return;

      var item = question.parentElement;
      var answer = item.querySelector('.funnel-faq__answer');
      var isOpen = item.classList.contains('funnel-faq__item--open');

      // Close all
      faqSection.querySelectorAll('.funnel-faq__item--open').forEach(function (openItem) {
        openItem.classList.remove('funnel-faq__item--open');
        var openAnswer = openItem.querySelector('.funnel-faq__answer');
        if (openAnswer) openAnswer.style.maxHeight = null;
      });

      // Toggle current
      if (!isOpen) {
        item.classList.add('funnel-faq__item--open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  }

  /* ---- Init ---- */
  document.addEventListener('DOMContentLoaded', function () {
    initStickyCta();
    initSectionTracking();
    initVideoTracking();
    initFunnelFaq();
  });
})();
